
import { TweenMax, TimelineMax, Power1, Elastic } from "gsap";
import { AudioManager, Track } from "../../../AudioManager";
import { IRandomInterval } from "../../../Context/RandomInterval";
import { ISystemContext } from "../../../Context/SystemContext";
import { MoneyFormatter } from "../../../MoneyFormatter";
import { FontResource } from "../../../ResourceManager/FontResource";
import { ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { BigWinCountAnimation } from "../../../slot/BigWinCountAnimation";
import { IBonusStartConfig, BonusFinish } from "../../../slot/SlotGame";
import { CanvasSprite } from "../../../slot/Sprite/CanvasSprite";
import { Translator } from "../../../Translator";
import { Size, Scale, CreateElement, SetStyles } from "../../.././MyHelpers";
import { BonuRecoverStatus } from "../SlotBonus";
import { SlotBonus2 } from "../SlotBonus2";
import { SpinAndHold2Params } from "./SpinAndHold2Params";
import { SpinAndHoldMessages } from "./SpinAndHoldMessages";
import { SpinAndHoldSession } from "./SpinAndHoldSession";
import { Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { MyCanvas, MyCanvasContext } from "../../MyCanvas";
import Jackpot from "../../../AdminMenu/pages/Jackpot.page.svelte";
import { SpinAndHoldCommonConfiguration } from "../../../api";

export class SpinAndHold2 extends SlotBonus2 implements Resourceful2 {

	protected view: HTMLElement = null;
	protected override resid: ResourceIdentifier;
	protected parentresid: ResourceIdentifier = null;
    protected params: SpinAndHold2Params;
	//protected transition: SceneTransition = null;

	protected gameTitle: HTMLElement = null;
	protected viewSize: Size;

	protected session: SpinAndHoldSession = new SpinAndHoldSession("Screen-2");

	//protected elemWon: HTMLElement = null;
	//protected elemPlayed: HTMLElement = null;
	//protected elemLeft: HTMLElement = null;
	//CHANGE SIMPLE TEXT BY CANVAS
	protected winCountcanvas: MyCanvas = null;
	protected ctx:MyCanvasContext = null;
	protected fontHeight:number = Scale.fh(135);
	protected fontHeightWinShow:number = Scale.fh(200);
	
	
	protected fontFamily: string;
	

	protected winStats: HTMLElement;
	protected win: HTMLElement = null;

	//protected wins: HTMLElement = null;
	protected bonustitle: HTMLElement = null;
	protected totalwin: HTMLElement = null;
	protected played: HTMLElement = null;
	protected left: HTMLElement = null;


	protected winCreditAnimation: TweenMax = null;
	protected winValues: any = { win: 0 };

	protected glowRemainig: TimelineMax = null;
	protected glow: any = { glow: 0 };
	//container for spins wins
	protected WinValueSprite: CanvasSprite = null;
	//container for spins left
	protected ContainerSprite:CanvasSprite=null;

	protected basepath: string = null;

	protected StickyBonus: HTMLElement = null;
	protected bigWinCountAnimation: BigWinCountAnimation = null;

	protected moneyFormatter: MoneyFormatter = null;
	public translator: Translator;

	protected TitleValueBackground:HTMLElement;
	//Create  AUDIO 
	protected audio:AudioManager ;

	protected SFXBackground: CanvasSprite = null;

	protected StickyBonusSprite: CanvasSprite = null;
	
	protected BonusStartTimer: IRandomInterval = null;

	protected systemContext: ISystemContext = null;

	protected FrameSprite: CanvasSprite = null;
	protected winContainer:HTMLElement = null;
	protected WinCountAnimation: BigWinCountAnimation = null;
	protected WinCanvasShow: MyCanvas = null;
	protected ctxWinCanvasShow: MyCanvasContext = null;

	protected BonusWin: HTMLElement = null;
	protected BonusWinSprite: CanvasSprite = null;

	
	protected BonusName(): string
	{
		return "SpinAndHold";
	}

	protected tl:TimelineMax =  new TimelineMax;
	
	public constructor(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration) {
		super(params.gameName, params);

		this.parentresid = gameResid;
		this.resid = gameResid.Add(this.bonusName + "2");
		this.translator = params.translator;
		this.systemContext = params.systemContext
		//INI AUDIO
		this.audio = params.audio;
		this.params = params;
		this.viewSize = params.viewSize;

		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/";

		this.view = CreateElement("div", {
			classes: [this.resid.Scope()],
			style: {
				position: "absolute",
				top: Scale.Ypx(0),
				left: Scale.Xpx(0),
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
			}
		});

		//this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.PickMessage.msgname, (m) => this.OnPick((<FreegameMessages.PickMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.SpinMessage.msgname, (m) => this.OnSpin((<SpinAndHoldMessages.SpinMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.PlusMessage.msgname, (m) => this.OnPlus((<SpinAndHoldMessages.PlusMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.WinValue.msgname, (m) => this.UpdateWinValue((<SpinAndHoldMessages.WinValue>m).win), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.StartShowWin2Screen.msgname, (m) => this.StartShowWin(), this.screenProtocolScope);
		//this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.ResetShowWin2Screen.msgname, (m) => this.ResetShowWin(), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.StartBounceFinalBonus.msgname, (m) => this.OnFinalMessageBegin(), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(SpinAndHoldMessages.StopBounceFinalBonus.msgname, (m) => this.OnFinalMessageEnd(), this.screenProtocolScope);
	
	
		//this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.WinMessage.msgname, (m) => this.Win((<FreegameMessages.WinMessage>m).session), this.screenProtocolScope);
		//this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.WinInterruptedMessage.msgname, (m) => this.WinInterrupt(), this.screenProtocolScope);
	

		this.moneyFormatter = params.moneyFormatter;

		this.systemContext = params.systemContext.CreateSubContext(this.bonusName);
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		//// Log.Debug(this.logGroup, this.)
		//resourceManager.Add(new HTMLResource(this.commonResourcesBasePath + "HoldAndSpin.2.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.commonResourcesBasePath + "HoldAndSpin.2.css", this.resid.ScopedResourceName("css"), this.parentresid.CSSScope()));

		
		//resourceManager.AddGlobal(new SpriteResource(this.gameResourcesBasePath + "transition", this.resid.Add("transition").Shared(), true, this.logGroup.Add("transition"), true));
		//YO
		//resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background2", "image"])));
		//Yo
		await this.PrepareFonts(resourceManager);
		//LOAD AUDIO
		await this.AudioPrepare(resourceManager);

		await this.TitlePrepare(resourceManager);
		await this.SpriteWinFramePrepare(resourceManager);
		
	}

	public AudioPrepare(resourceManager: IWriteOnlyResourceManager):void
	{
		//LOAD LIGHTING
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/TitleAnim" + Settings.audioFormat, this.resid.ScopedResourceName("TitleAnim")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/sfxnumber" + Settings.audioFormat, this.resid.ScopedResourceName("SFXnumber")));
	
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void 
	{	
		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "fontStyle.ttf", this.resid.ScopedResourceName("font")));
	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager) 
	{
		resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.resid.ScopedResourceName(["title", "image"])));
		resourceManager.AddGlobal(new SpriteResource(this.params.gameBonusResourcesBasePath + "ValueContainer", ResourceIdentifier.Global.Add("HoldAndSpin").Add(this.gameName+"ValueContainer"), true, this.logGroup.Add(this.gameName), true));
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/TextContainer", ResourceIdentifier.Global.Add("HoldAndSpin").Add("TextContainer"), true, this.logGroup.Add("TextContainer"), true));
		resourceManager.AddGlobal(new SpriteResource(this.params.gameBonusResourcesBasePath + "sfxnumber", this.resid.Add("HoldAndSpin").Add("sfxnumber"), true, this.logGroup.Add("sfxnumber"), true));
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/BonusTitle", ResourceIdentifier.Global.Add("StickyBonus").Add("BonusTitleStickyBonus"), true, this.logGroup.Add("freegame"), true));
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/StickyTitle", ResourceIdentifier.Global.Add("StickyBonus").Add("StickyTitle"), true, this.logGroup.Add("freegame"), true));
	
	
	}

	
	


	//ADD SPRITE WIN COUNT CANVAS
	protected SpriteWinFramePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + `resources/FramesWinSpine/${Settings.JackpotDisplayType}/frameSpriteWin`, this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
	}
	
	
	protected SpriteWinFrameLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.winContainer = CreateElement("div", {
			classes: [this.resid.Scope(), "WinContainer"],
			parentToAppend: this.view,
			style: {
				position : "absolute",
				top: Scale.Ypx(288),
				//left: "0px",
				width: Scale.Wpx(1920),
				height: Scale.Hpx(423),
				display:"none",
				//flexDirection:"column",
				zIndex:"3",
				overflow:"hidden"
			}
		});

		// let BackgroundContainer = CreateElement("div", {
		// 	classes: ["background-container"],
		// 	parentToAppend: this.winContainer,
		// 	style: {
		// 		backgroundColor:"rgba(0,0,0,0.7)",
		// 		width: Scale.Wpx(1590),
		// 		height: Scale.Hpx(347),
		// 		position:"absolute",
		// 		top: Scale.Ypx(40),
		// 		left: Scale.Xpx(76),
		// 	}
		// });

		
		this.FrameSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite, canvasSize: new Size(Scale.W(1720), Scale.H(500))});
		this.FrameSprite.View().style.position="absolute";
		this.FrameSprite.View().style.top = Scale.Ypx(-28);
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		this.winContainer.appendChild(this.FrameSprite.View());

		//this.WinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(1920), Scale.H(400)), Scale.fh(600),  this.resid.ScopedResourceName("bigwincount"));
		//this.WinCountAnimation.View().style.position = "relative";
		//this.WinCountAnimation.View().style.top = Scale.Ypx(-47);


		// TODO don't append into canvas?
		//this.FrameSprite.View().appendChild(this.WinCountAnimation.View());

		
	}

	public StickyBonusLoaded(resourceManager: IReadOnlyResourceManager) {

		this.winStats = CreateElement("div", {
			classes: ["win-stats"],
			parentToAppend: this.view
		});

		
		this.WinValueSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("HoldAndSpin").Add(this.gameName + "ValueContainer")).sprite, canvasSize: new Size(Scale.W(836), Scale.H(730))});
		this.WinValueSprite.Scale(0.9);
		this.WinValueSprite.View().style.display = "block";
		this.WinValueSprite.View().style.position = "absolute";
		this.WinValueSprite.View().style.left = Scale.Xpx(537);
		this.WinValueSprite.View().style.top = Scale.Ypx(216);
		this.WinValueSprite.View().style.zIndex = ZIndex.winValueSprite.toString();

		this.WinValueSprite.Start(true);
		this.winStats.appendChild(this.WinValueSprite.View());

		this.win = CreateElement("div", {
			classes: ["win"],
			parentToAppend: this.winStats,
			style: {
				boxSizing: "border-box",
				position: "relative",
				textAlign: "center",
				verticalAlign: "center",
				fontSize: `${Scale.fh(10)}em`,
				//top: Scale.Ypx(126),
				fontFamily:"NotoSansDisplay-ExtraBold",
				textShadow: `0px ${Scale.XYpx(10)} ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(20)} black`,
				color: "yellow",



				width: Scale.Wpx(1920),
				top: Scale.Ypx(355),
				zIndex: ZIndex.HoldAndStopBonusStats.toString(),
			}
		});

		this.totalwin = CreateElement("div", {
			classes: ["total-win"],
			parentToAppend: this.winStats,
			style: {
				position: "relative",
				//top: Scale.Ypx(80),
				width: Scale.Wpx(1920),
				textAlign: "center",
				//fontSize: `${Scale.fh(5)}em`,
				fontFamily:"NotoSansDisplay-ExtraBold",
				textShadow: `0px ${Scale.XYpx(10)} ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(20)} black`,
				color: "yellow",

				left: Scale.Xpx(-5),
				top: Scale.Ypx(260),
				zIndex: ZIndex.HoldAndStopBonusStats.toString(),
				display: "block",
				fontSize: Scale.fhpx(58),
			}
		});




		this.totalwin.appendChild(this.translator.Anchor(() => this.translator.t.totalwinHoldAndSpin));
	}

	protected StickySpinTitle(resourceManager: IReadOnlyResourceManager)
	{
		this.StickyBonusSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("StickyBonus").Add("StickyTitle")).sprite, canvasSize: new Size(Scale.W(1720), Scale.H(350))});
		this.StickyBonusSprite.Scale(0.85);
		this.StickyBonusSprite.View().style.position = "absolute";
		this.StickyBonusSprite.View().style.top = Scale.Ypx(10);
		this.StickyBonusSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));
		this.StickyBonus.style.zIndex = ZIndex.HoldAndStopTitle.toString();
		this.StickyBonus.appendChild(this.StickyBonusSprite.View());
	}

	protected RemainigContainer(resourceManager: IReadOnlyResourceManager) {
		this.freegameStats = CreateElement("div", {
			classes: ["freegame-stats"],
			parentToAppend: this.view,
			style: {
				justifyContent: "center",
				display: "flex",
				position: "absolute",
				width: Scale.Wpx(1920),
				height: Scale.Hpx(270),
				bottom: Scale.Ypx(-12),
				zIndex: ZIndex.HoldAndStopBonusStats.toString(),
			}
		});

		let freegameLeftNum = CreateElement("div", {
			classes: ["freegames-left", "freegames-num"],
			parentToAppend: this.freegameStats,
			style: {
				width: (Scale.W(1920) / 3) + "px",
				display: "flex",
				flexDirection: "row",
				boxSizing: "border-box",

				zIndex: ZIndex.HoldAndStopBonusStats.toString()
			}
		});

		this.left = CreateElement("div", {
			classes: ["freegames-num-title"],
			id: "left",
			parentToAppend: freegameLeftNum,
			style: {

				//border: 1px solid green;
				boxSizing: "border-box",

				fontSize: `${Scale.fh(5)}em`,
				fontFamily:"NotoSansDisplay-ExtraBold",
				textShadow: `0px ${Scale.XYpx(10)} ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(20)} black`,
				color: "yellow",
				textAlign: "center",
				alignItems: "center",
				alignSelf: "center",
				margin: Scale.XYpx(25),


				position: "relative",
				left: Scale.Xpx(-14),
				top: Scale.Ypx(8),
				lineHeight: Scale.fhpx(73),
				display: "block",
			}
		});

		let freegamesLeftValue = CreateElement("div", {
			classes: ["freegames-num-value", "freegames-left-value"],
			parentToAppend: freegameLeftNum
		});


		this.ContainerSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("HoldAndSpin").Add("TextContainer")).sprite, canvasSize: new Size(Scale.W(950), Scale.H(270))});
		this.ContainerSprite.View().style.display = "vissible";
		this.ContainerSprite.ScaleNonUniform(1.5, 1);
		this.ContainerSprite.View().style.position = "absolute";
		this.ContainerSprite.View().style.left = Scale.Xpx(486);
		this.ContainerSprite.Start(true);


		this.freegameStats.appendChild(this.ContainerSprite.View());

		this.left.appendChild(this.translator.Anchor(() => this.translator.t.totalleftHoldAndSpin));
	}

	protected BonusWinLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.BonusWinSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("StickyBonus").Add("BonusTitleStickyBonus")).sprite, canvasSize: new Size(Scale.W(1720), Scale.H(350))});
		SetStyles(this.BonusWinSprite.View(), {
			position: "absolute",
			top: Scale.Ypx(0),
			zIndex:ZIndex.BonusWin.toString(),
			
		});

		this.BonusWinSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));
		this.StickyBonus.appendChild(this.BonusWinSprite.View());
	}

	protected freegameStats: HTMLElement = null;

	protected CreateShowAnim(){
		this.tl = new TimelineMax({
			paused: true,
			repeat: 0,
		});

		this.tl

			/* ball bounce up */
			.fromTo(this.StickyBonus, 0.5, {

				y: 0,

			}, {
				y: Scale.Y(-100),
				ease: Power1.easeOut, transformOrigin: "50% 50%",
			}
				, "bounce")

			/* ball bounce down */
			.to(this.StickyBonus, 0.4, {
				transformOrigin: "50% 50%",
				y: 0,
				ease: Power1.easeIn
				//ease: Power1.easeInOut
			}, "bounce2")

			/* ball squash */
			.to(this.StickyBonus, 0.35, {
				transformOrigin: "50% 100%",
				//scaleX: Scale.X(1),
				scaleY: 0.30,
				ease: Power1.easeInOut
				//ease: Bounce.easeOut
			}, "bounce3-=0.04")

			.to(this.StickyBonus, 0.35, {
				transformOrigin: "100% 100%",
				//scaleX: Scale.X(1),
				scaleY: 1,
				ease: Power1.easeInOut
				//ease: Bounce.easeOut
			}, "bouncefinal");
	}


	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		//Yo
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background2", "image"])).CssBackground();
		// this.view.style.backgroundSize = "contain";
		// this.view.style.backgroundRepeat = "no-repeat";
		//Yo
		this.StickyBonus = CreateElement("div", {
			classes: ["game-title"],
			parentToAppend: this.view,
			style: {
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",

				display: "flex",
				alignContent: "center",
				justifyContent: "center",
				width: Scale.Wpx(1920),
				height:  Scale.Hpx(323),
				position: "absolute",
				top:  Scale.Xpx(0),
				overflow: "hidden",
			}
		});

		// let bonusesFeaturesDescription = CreateElement("div", {
		// 	classes: ["features-bonuses-description"],
		// 	parentToAppend: this.view
		// });

		
		
		//create Win sra stats whit sprite 
		this.StickyBonusLoaded(resourceManager);
		//create AnimShow
		this.CreateShowAnim();
		this.StickySpinTitle(resourceManager);
		//Create remaining play stat spin and hold whit sprite 
		this.RemainigContainer(resourceManager);
		this.BonusWinLoaded(resourceManager);


		// ??
		this.played = this.view.querySelector("#played");
		
		// this.win.appendChild(countView);
		this.BigCountAnimation(resourceManager);
		//this.bonustitle.appendChild(this.translator.Anchor(() => this.translator.t.TitleValueBackground));
		//this.totalwin.appendChild(this.translator.Anchor(() => this.translator.t.totalwinHoldAndSpin));
		//this.wins.appendChild(this.translator.Anchor(() => this.translator.t.win));
		//this.played.appendChild(this.translator.Anchor(() => this.translator.t.played));
		

		
		this.CanvaswinCount(resourceManager);
		this.SpriteWinFrameLoaded(resourceManager);
		this.CanvaswinCountShow(resourceManager);
	}

	protected BigCountAnimation(resourceManager: IReadOnlyResourceManager)
	{
		this.bigWinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(1920), Scale.H(400)), Scale.fh(200),  this.resid.ScopedResourceName("bigwincount"));
			
		let countView = this.bigWinCountAnimation.View();
		countView.style.position = "relative";
		//countView.style.top = Scale.Ypx(600);
		//countView.style.left = Scale.Xpx(32);
		//countView.style.width = Scale.Wpx(1920);
		countView.style.pointerEvents = "none";
		
		this.win.appendChild(countView);
		countView = null;
	}

	protected CanvaswinCountShow(resourceManager: IReadOnlyResourceManager)
	{
		this.WinCanvasShow = new MyCanvas(new Size(Scale.W(1460), Scale.H(230)), {
            style: {
                top: Scale.Ypx(106),
				left: Scale.Xpx(123),
				position: "absolute",
				alignItems: "center",
				justifyContent: "center",
				zIndex: ""+ ZIndex.BonusWin,
				display: "none",
            }
        });		
		
		this.winContainer.appendChild(this.WinCanvasShow.view);		

	}


	protected CanvaswinCount(resourceManager: IReadOnlyResourceManager)
	{
		this.winCountcanvas = new MyCanvas(new Size(Scale.W(354), Scale.H(200)), {
            style: {
				top: Scale.Ypx(-6),
				left: Scale.Ypx(-63),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin,
				display: "block",
            }
        });
		
		

		
		
		this.SFXBackground = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("HoldAndSpin").Add("sfxnumber")).sprite, canvasSize: new Size(Scale.W(250), Scale.H(250))});
		this.SFXBackground.View().style.display="block";
		this.SFXBackground.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("SFXnumber")));
		
		this.SFXBackground.View().style.position="absolute";
		this.SFXBackground.View().style.left = Scale.Xpx(-23);
		this.SFXBackground.View().style.top = Scale.Ypx(-28);
		
		
		let value:HTMLElement = this.view.querySelector(".freegames-left-value");
		value.style.position="relative";
		value.style.left = Scale.Xpx(-66);
		value.style.top = Scale.Ypx(42);		
		value.appendChild(this.winCountcanvas.view);		
		value.appendChild(this.SFXBackground.View());
			
		value = null;


	}
	/******
		
	******/

	public Prepare(bonusStartConfig: IBonusStartConfig)
	{

	}

	public Start(): void {
		if (this.session == null) {
			throw new Error("Session must not be null");

		}

		// clear values before start
		//this.elemWon.innerHTML = "?";
		//this.elemPlayed.innerHTML = "?";
		//this.elemLeft.innerHTML = "?";
		this.SetTextCanvas("?",this.winCountcanvas, this.fontHeight);
		if(this.bigWinCountAnimation!=null){
			this.bigWinCountAnimation.Display(this.moneyFormatter.CentsToCredit(0));
		}
		this.SetTextCanvas("?",this.WinCanvasShow , this.fontHeightWinShow);
		this.WinValue=0;
		//this.win.innerHTML = "?";
		
		//this.bigWinCountAnimation.Display(0);
		//this.BonusStartTimer.Start();
		//this.transition.Start();
		this.session.Reset();
		this.ResetShowWin();

	}

	public SetTextCanvas(text:string, Canvas: MyCanvas , fontHeight : number)
	{
		Canvas.context.clearRect(0, 0, Canvas.size.Width, Canvas.size.Height);
		Canvas.context.font = " " +fontHeight + "px " + this.resid.ScopedResourceName("bigwincount");
		let color: string = "orangered";
		let color2: string = "yellow";
		let gradient = Canvas.context.createLinearGradient(Canvas.size.Width / 2,
			Canvas.size.Height / 2 -fontHeight / 2,
			Canvas.size.Width / 2,
			Canvas.size.Height / 2 +fontHeight / 2
		);
		gradient.addColorStop(0, color);
		gradient.addColorStop(0.70, color2);
		gradient.addColorStop(1, color);
		Canvas.context.fillStyle = gradient;
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;

		Canvas.context.strokeStyle = "black";
		Canvas.context.lineWidth = Scale.fh(10);  
		Canvas.context.strokeText(text,(Canvas.size.Width/2),(Canvas.size.Height/2));
		
		Canvas.context.strokeStyle = "white";
		Canvas.context.lineWidth =Scale.fh(10)/2;
		Canvas.context.strokeText(text,(Canvas.size.Width/2),(Canvas.size.Height/2));
	
		Canvas.context.fillText(text,(Canvas.size.Width/2),(Canvas.size.Height/2));
		Canvas.RestoreContext();
		gradient = null;
		color = null;
		color2 = null;		
	}



	public Update(): void {
		//this.transition.Update();
		
		this.WinValueSprite.Update();
		this.ContainerSprite.Update();
		this.SFXBackground.Update();
		this.StickyBonusSprite.Update();
		this.FrameSprite.Update();
		this.BonusWinSprite.Update();
		if(this.WinCanvasShow.WasContextLost()){
			this.SetTextCanvas(this.moneyFormatter.FormatCurrency(this.WinValue),this.WinCanvasShow , this.fontHeightWinShow);	
		}
		if(this.winCountcanvas.WasContextLost){
			this.SetTextCanvas(this.session.RunsRemaining.toString(),this.winCountcanvas , this.fontHeight);
		}
		//if (this.bigWinCountAnimation != null) {
			this.bigWinCountAnimation.Update(this.session.ScattersDisplayed);
		//}
	}

	public View(): HTMLElement {
		return this.view;
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {

	}
	public Hide(): void {
		this.view.style.display = "none";
	}
	public Show(): void {
		this.view.style.display = "block";
	}
	public Reset(): void {
	}

	/*********
		SCREEN PROTOCOL EVENTS
	**********/

	// protected OnPick(session: FreegameSession): void {
	// 	if (session == null) {
	// 		throw new Error("Session must not be null");

	// 	}
	// 	this.WinValueSprite.Start(false);
	// 	//this.transition.Start();
	// 	this.session.Update(session);
	// 	this.ApplySession();
	// }


	protected OnSpin(session: SpinAndHoldSession): void {
		if (session == null) {
			throw new Error("Session must not be null");
		}
		this.session.Update(session);
		this.ApplySession();
		
		
	}
	protected OnPlus(session: SpinAndHoldSession): void {

		if (session == null) {
			throw new Error("Session must not be null");

		}

		if (session.RunsRemaining > this.session.RunsRemaining) {
			this.SFXBackground.Start(false);
			this.StickyBonusSprite.Start(false);
			//this.WinValueSprite.Start(false);
				

		}

		this.session.Update(session);
		setTimeout(() =>this.ApplySession(),300);
	}

	protected WinValue:number=0;
	protected UpdateWinValue(Win:number)
	{

		this.FrameSprite.Start(false);
		this.WinValue+=Win;
		//let value:string=this.moneyFormatter.CentsToCredit(this.WinValue)
		this.SetTextCanvas(this.moneyFormatter.FormatCurrency(this.WinValue),this.WinCanvasShow , this.fontHeightWinShow);
	
		this.BonusWinSprite.Start(false);
	}

	protected OnFinalMessageBegin() {

		this.tl.repeat(-1);
		this.tl.play();
	}

	protected OnFinalMessageEnd() {
		this.tl.restart();
		this.tl.pause();
		this.StickyBonus.style.transform="";
		this.ResetShowWin();
	}


	protected StartShowWin() {
		TweenMax.fromTo(this.winContainer, 2.5, {
			x: this.viewSize.Width,
		}, {
			x: Scale.X(110), ease: Elastic.easeOut.config(0.50, 0.4)
		});

		this.tl.repeat(0);
		this.tl.play();

		//this.FrameSprite.View().style.display="block";
		this.WinValueSprite.View().style.display = "none";
		this.ContainerSprite.View().style.display = "none";
		this.SFXBackground.View().style.display = "none";
		this.winCountcanvas.View().style.display = "none";
		this.totalwin.style.display = "none";
		this.left.style.display = "none";
		if (this.bigWinCountAnimation != null) {
			this.bigWinCountAnimation.View().style.visibility = "hidden";
		}
		this.win.style.display = "none";
		this.WinCanvasShow.View().style.display = "block";
		this.winContainer.style.display = "flex";
		this.StickyBonusSprite.Hide();
		this.BonusWinSprite.Show();
	}

	protected ResetShowWin()
	{
		//this.FrameSprite.View().style.display="none";
		this.winContainer.style.display="none";
		this.winContainer.style.visibility="none";
		this.WinValueSprite.View().style.display="block";
		this.ContainerSprite.View().style.display="block";
		this.SFXBackground.View().style.display="block";
		this.winCountcanvas.View().style.display="block";
		this.totalwin.style.display="block";
		this.left.style.display="block";
		this.win.style.display="block";
		if(this.bigWinCountAnimation!=null){
			this.bigWinCountAnimation.View().style.visibility = "visible";
			this.bigWinCountAnimation.View().style.display="block";
		}
		this.WinCanvasShow.View().style.display="none";
		//Create twwin anim for hide 
		this.StickyBonusSprite.Show();
		this.BonusWinSprite.Hide();
	}


	// protected Win(session: FreegameSession): void {
	// 	if (session == null) {
	// 		throw new Error("Session must not be null");

	// 	}

	// 	this.session.Update(session);
	// 	this.ApplySession();
	// 	this.bigWinCountAnimation.View().style.display = "block";

	// 	this.winCreditAnimation = TweenMax.fromTo(
	// 		this.winValues,
	// 		this.session.winDuration,
	// 		{ win: this.session.totalWin - session.win },
	// 		{
	// 			win: this.session.totalWin, roundProps: "win",
	// 			onUpdate: () => {
	// 				//this.bigWinCountAnimation.Display(this.moneyFormatter.CentsToCredit(this.winValues.win));
	// 				//this.win.innerHTML = ""+(this.winValues.win);
	// 				//this.panel.SetWin(""+this.winValues.win, ""+this.winValues.win);
	// 			}
	// 		}
	// 	);
	// }

	protected WinInterrupt(): void {
		if (this.winCreditAnimation) {
			this.winCreditAnimation.kill();
		}

		//this.bigWinCountAnimation.Display(this.moneyFormatter.CentsToCredit(this.session.awarded));
	}

	protected ApplySession() {
		//this.elemWon.innerHTML = "" + this.session.awarded;
		//this.elemPlayed.innerHTML = "" + this.session.played;
		//this.elemLeft.innerHTML = "" + this.session.left;
		
		this.SetTextCanvas(this.session.RunsRemaining.toString(),this.winCountcanvas, this.fontHeight);
		if(this.bigWinCountAnimation!=null){
		this.bigWinCountAnimation.Display(this.session.ScattersDisplayed);
		}
		
		//this.bigWinCountAnimation.Display(this.session.played);

		//this.win.innerHTML = ""+this.session.totalWin;
	}

	public Stop() {
		if(this.bigWinCountAnimation!=null){
		this.bigWinCountAnimation.View().style.display = "none";
		}
	}
}
